module.exports = __webpack_public_path__ + "img/image_service_1.648601c6.png";